import React from 'react';
import styled from 'styled-components';

type RateValueProps = {
  returnOfRate: string,
  fontSize?: number,
};

export default ({ returnOfRate, fontSize }: RateValueProps) => {
  const returnRateStrHelper = value => {
    const rates = value.split(';');
    return (
      <>
        {rates[0]}
        <span>%</span>
        {`-${rates[1]}`}
        <span>%</span>
      </>
    );
  };

  return <Wrapper fontSize={fontSize}>{returnRateStrHelper(returnOfRate)}</Wrapper>;
};

const Wrapper = styled.span`
  font-size: ${({ fontSize }) => `${fontSize || 24}px`};
  line-height: 28px;
  color: #70a800;
  > span {
    font-size: 14px;
  }
`;
